import { FormControl, FormHelperText, Checkbox } from '@mui/material';
import { CheckboxCard } from '@vayufp/coast-components';
import { FormikState, FormikHandlers, FormikHelpers } from 'formik';
import { ReactElement } from 'react';

type Props = Omit<React.ComponentProps<typeof Checkbox>, 'value' | 'onChange' | 'error' | 'defaultValue'> &
  Omit<React.ComponentProps<typeof CheckboxCard>, 'onChange'> & {
    margin?: React.ComponentProps<typeof FormControl>['margin'];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: FormikHandlers & FormikState<any> & FormikHelpers<any>;
    name: string;
    label: string;
  };

const FormikCheckboxCard = (props: Props): ReactElement => {
  const { margin: _margin, name, label, description, id, formik, ...rest } = props;

  const meta = formik.getFieldMeta<boolean>(name);

  const onChange = (checked: boolean) => {
    void formik.setFieldValue(name, checked);
  };

  return (
    <FormControl margin="none" fullWidth error={!!meta.error}>
      <CheckboxCard
        label={label}
        description={description}
        id={id}
        name={name}
        checked={meta.value}
        onChange={onChange}
        {...rest}
      />
      <FormHelperText>{meta.touched && meta.error}</FormHelperText>
    </FormControl>
  );
};

export { FormikCheckboxCard };
